/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressRotateCredentials } from "../funcs/networkIngressRotateCredentials.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngress } from "../models/components/networkingress.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RotateNetworkIngressCredentialsRequest,
  RotateNetworkIngressCredentialsSecurity,
} from "../models/operations/rotatenetworkingresscredentials.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RotateNetworkIngressCredentialsMutationVariables = {
  request: RotateNetworkIngressCredentialsRequest;
  security?: RotateNetworkIngressCredentialsSecurity | undefined;
  options?: RequestOptions;
};

export type RotateNetworkIngressCredentialsMutationData = NetworkIngress;

export type RotateNetworkIngressCredentialsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * rotateCredentials networkIngress
 *
 * @remarks
 * Replace the provider OAuth client credentials without returning either value.
 */
export function useRotateNetworkIngressCredentialsMutation(
  options?: MutationHookOptions<
    RotateNetworkIngressCredentialsMutationData,
    RotateNetworkIngressCredentialsMutationError,
    RotateNetworkIngressCredentialsMutationVariables
  >,
): UseMutationResult<
  RotateNetworkIngressCredentialsMutationData,
  RotateNetworkIngressCredentialsMutationError,
  RotateNetworkIngressCredentialsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRotateNetworkIngressCredentialsMutation(client, options),
    ...options,
  });
}

export function mutationKeyRotateNetworkIngressCredentials(): MutationKey {
  return ["@gram/client", "networkIngress", "rotateCredentials"];
}

export function buildRotateNetworkIngressCredentialsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RotateNetworkIngressCredentialsMutationVariables,
  ) => Promise<RotateNetworkIngressCredentialsMutationData>;
} {
  return {
    mutationKey: mutationKeyRotateNetworkIngressCredentials(),
    mutationFn: function rotateNetworkIngressCredentialsMutationFn({
      request,
      security,
      options,
    }): Promise<RotateNetworkIngressCredentialsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(networkIngressRotateCredentials(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
